import { IBaseResponse } from '../BaseResponse';

export interface IReportEmailSettings {
  ReceiveFileReportEmail: boolean;
  FileReportPeriodicity: ReportPeriodicityEnum;
  ReceiveTopicReportEmail: boolean;
  TopicReportPeriodicity: ReportPeriodicityEnum;
  ReceivePlottReportEmail: boolean;
  PlottReportPeriodicity: ReportPeriodicityEnum;
}

export interface IRequestReportEmailSettings {
  receiveFileReportEmail: boolean;
  fileReportPeriodicity: ReportPeriodicityEnum;
  receiveTopicReportEmail: boolean;
  topicReportPeriodicity: ReportPeriodicityEnum;
  receivePlottReportEmail: boolean;
  plottReportPeriodicity: ReportPeriodicityEnum;
}

export enum ReportPeriodicityEnum {
  Weekly = 1,
  Daily = 2,
}

export interface IReportAxiosResponse extends IBaseResponse<IReportEmailSettings> { }

export interface IReportCreateAxiosResponse extends IBaseResponse<null> { }

export interface IReportUpdateAxiosResponse extends IBaseResponse<null> { }
